var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixUrlsApiV2PublishedSiteUrls from '@wix/ambassador-urls-api-v2-published-site-urls/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var UrlType;
(function (UrlType) {
    /** Unknown URL type. */
    UrlType["UNKNOWN"] = "UNKNOWN";
    /** URLs with premium domain attached to the site. */
    UrlType["PREMIUM"] = "PREMIUM";
    /** Default URL before premium domain was attached to the site. */
    UrlType["FREE"] = "FREE";
})(UrlType || (UrlType = {}));
export var UrlTypeFilter;
(function (UrlTypeFilter) {
    /** return all URLs */
    UrlTypeFilter["ALL"] = "ALL";
    /** return only premium URLs */
    UrlTypeFilter["PREMIUM"] = "PREMIUM";
    /** return only free URLs */
    UrlTypeFilter["FREE"] = "FREE";
})(UrlTypeFilter || (UrlTypeFilter = {}));
const _listPublishedSiteUrlsRequest = {};
const _listPublishedSiteUrlsResponse = {};
const _listSiteUrlsRequest = {};
const _listSiteUrlsResponse = {};
/**
 * Retrieves a list of a site's published URLs.
 * @internal
 * @documentationMaturity preview
 * @permissionId SITE_URLS.READ
 * @adminMethod
 * @returns deprecated. Do not use
 * @deprecated method is deprecated due to...
 * @replacedBy UrlsApi.ListPublishedSiteUrls
 * @targetRemovalDate 2024-04-01
 */
export function listSiteUrls(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filters: '$[0].filters' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listSiteUrlsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listSiteUrlsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixUrlsApiV2PublishedSiteUrls.listSiteUrls(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of a site's published URLs.
 * If a site hasn't been published, the call returns an empty array.
 * @public
 * @documentationMaturity preview
 * @permissionId SITE_URLS.READ
 * @adminMethod
 */
export function listPublishedSiteUrls(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filters: '$[0].filters' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listPublishedSiteUrlsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listPublishedSiteUrlsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixUrlsApiV2PublishedSiteUrls.listPublishedSiteUrls(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=urls-api-v2-published-site-urls.universal.js.map